import React, { memo } from 'react';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function KPIBlock({ block }) {
    const items = extractBlockItems(block);
    if (!items.length) return null;

    return (
        <section className={styles.kpiBlock} aria-label={block.title || 'Key metrics'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <div className={styles.kpiGrid}>
                {items.map((item, index) => {
                    const label = item.label || item.title || item.name;
                    const value = item.value ?? item.count;
                    if (label == null && value == null) return null;
                    const tone = String(item.tone || item.variant || 'neutral').toLowerCase();
                    return (
                        <article
                            key={item.id || `${label}-${index}`}
                            className={`${styles.kpiCard} ${styles[`kpiTone${tone}`] || ''}`.trim()}>
                            {label ? <div className={styles.kpiLabel}>{label}</div> : null}
                            {value != null ? <div className={styles.kpiValue}>{value}</div> : null}
                            {item.description ? (
                                <div className={styles.kpiDescription}>{item.description}</div>
                            ) : null}
                        </article>
                    );
                })}
            </div>
        </section>
    );
}

export default memo(KPIBlock);
